import {
  GetGalleriesDocument,
  GetGalleryEntryDocument,
} from '@/graphql/generated-types';
import { apolloClient } from '@/utils/apollo';
import SentryGraphQLError from '@/utils/exceptions/SentryGraphQLError';

const getGalleries = async (departmentId: string) => {
  const response = await apolloClient.query({
    query: GetGalleriesDocument,
    variables: {
      filter: {
        departments: [departmentId],
      },
    },
    errorPolicy: 'all',
    fetchPolicy: 'no-cache',
  });

  if (response.data?.galleries) {
    return response.data.galleries;
  }

  throw new SentryGraphQLError(`api.gallery.getGalleries`, response);
};

const getGalleryEntry = async (id: string) => {
  const response = await apolloClient.query({
    query: GetGalleryEntryDocument,
    variables: {
      id,
    },
    errorPolicy: 'all',
    fetchPolicy: 'no-cache',
  });

  if (response.data?.galleryEntry) {
    return response.data.galleryEntry;
  }

  throw new SentryGraphQLError(`api.gallery.getGalleryEntry`, response);
};

export default {
  getGalleries,
  getGalleryEntry,
};
